import { useEffect } from 'react';
import { applyVoiceTourOverrides } from '../lib/pageNarrations';

const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : '/api';

/**
 * Mounted at the App root. Fetches admin Voice Tour overrides on boot
 * and re-fetches whenever the admin saves a change (via the
 * `voice-tour-overrides-changed` window event). Renders nothing.
 */
export default function VoiceTourOverridesLoader() {
  useEffect(() => {
    const fetchOverrides = async () => {
      try {
        const r = await fetch(`${API}/voice-tours/active`);
        if (!r.ok) return;
        const data = await r.json();
        applyVoiceTourOverrides(data?.overrides || []);
        window.__VOICE_TOURS_ENABLED__ = data?.tours_enabled !== false;
        window.dispatchEvent(new CustomEvent('voice-tours-global-changed'));
      } catch {
        // silent — fall through to static defaults
      }
    };
    fetchOverrides();
    const onChange = () => fetchOverrides();
    window.addEventListener('voice-tour-overrides-changed', onChange);
    return () => window.removeEventListener('voice-tour-overrides-changed', onChange);
  }, []);
  return null;
}
